var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwo = function SvgTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 19.856q.544-.432.496-.4a59 59 0 0 0 2.464-2.128 10 10 0 0 0 1.536-1.744q.624-.912.624-1.776 0-.656-.304-1.024-.305-.368-.912-.368t-.96.464q-.336.448-.336 1.28h-2.64q.031-1.36.576-2.272.56-.912 1.456-1.344a4.65 4.65 0 0 1 2.016-.432q1.904 0 2.864.976.976.976.976 2.544 0 1.712-1.168 3.184-1.168 1.456-2.976 2.848h4.32v2.224H12z"
  })));
};
export default SvgTwo;